'use client';

import { ChannelCard } from '@/components/molecules/ChannelCard';
import { useLiveChannel } from '@/hooks';
import { useState } from 'react';
import styles from './leaguecard.module.scss';

export interface LeagueCardProps {
    channelName: string;
    channelId: string;
    channelLogo: AEMImage | undefined;
    subTitle?: React.ReactNode;
    listenUrl: string;
    borderColor: string;
    showSchedulesUrl?: Link;
    channelPlayingInfo?: ChannelPlaying;
}

export function LeagueCard({
    channelName,
    channelId,
    channelLogo,
    subTitle,
    listenUrl,
    borderColor,
    showSchedulesUrl,
    channelPlayingInfo,
}: LeagueCardProps): React.JSX.Element {
    const [album, setAlbum] = useState({
        title: channelPlayingInfo?.content.title || '',
        artist: channelPlayingInfo?.content.artist || '',
        art: channelPlayingInfo?.album.art || channelLogo?.url || '',
    });
    const [activeItem, setActiveItem] = useState<number>();

    useLiveChannel([channelId], (response: MountainResponse) => {
        const nowPlayingChannel = response.channels;

        if (nowPlayingChannel && channelId) {
            setAlbum({
                title: nowPlayingChannel[channelId].content.title || '',
                artist: nowPlayingChannel[channelId].content.artists
                    ? nowPlayingChannel[channelId].content.artists[0].name
                    : '',
                art: nowPlayingChannel[channelId].content.album?.art || channelLogo?.url || '',
            });
        }
    });

    return (
        <div className={styles.leagueCard}>
            <ChannelCard
                radioImageUrl={channelLogo?.url || ''}
                radioImageAlt={channelLogo?.altText || channelName}
                radioImageHeight={132}
                radioImageWidth={132}
                title={channelName || ''}
                subTitle={subTitle}
                showAndScheduleLink={showSchedulesUrl?.href}
                showAndScheduleLinkText={showSchedulesUrl?.link_text}
                showsAndScheduleLinkAriaLabel={showSchedulesUrl?.aria_label}
                showAndScheduleLinkTarget={showSchedulesUrl?.link_target}
                listenLink={listenUrl}
                listenLinkAriaLabel={`Listen live to ${channelName}`}
                borderColor={borderColor}
                disableShadow={true}
                allowTextSquash={true}
                albumImageSrc={album.art}
                albumImageAlt={album.title}
                songTitle={album.title}
                songArtist={album.artist}
                index={0}
                activeItem={activeItem}
                onKebabClick={() => setActiveItem((prev) => (prev === 0 ? undefined : 0))}
            />
        </div>
    );
}
